import {isArray} from 'lodash';
import buildQuery from 'odata-query';
import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getEcaFields} from '../../../../api/EcaServices';
import {RootState} from '../../../../redux/store';
import {isEmpty} from '../../../../utils/utils';
import {FieldCategoryType} from '../../field-management/custom-field/FieldView';
import {
  FieldCategoryMappingByValue,
  IFieldModal,
} from '../../field-management/custom-field/constant';

interface UseQueryFieldReturn {
  loading: boolean;
  fields: IFieldModal[];
}

export const useQueryField = (type: FieldCategoryType): UseQueryFieldReturn => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient.clientId
  );
  const projectId = useSelector((state: RootState) => state.reports.projectId);

  const fieldTemplateId = useSelector(
    (state: RootState) => state.query.index?.fieldTemplateId ?? ''
  );

  const [state, setState] = useState({
    loading: false,
    fields: [],
  });

  const getFields = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    let filterParams = '';
    const filterFieldCategory = FieldCategoryMappingByValue[type];
    const filter = [];
    if (isArray(filterFieldCategory)) {
      filter.push({and: filterFieldCategory});
    } else {
      filter.push(filterFieldCategory);
    }
    filterParams = buildQuery({filter}).replace(/^\?\$filter=/, '');

    const fieldTemplateIdParam = !isEmpty(fieldTemplateId)
      ? `&fieldTemplateId=${fieldTemplateId}`
      : '';

    const params = `clientId=${clientId}&projectId=${projectId}&filter=${filterParams}${fieldTemplateIdParam}&top=10000`;

    getEcaFields(params)
      .then((result) => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          fields: result?.data?.data ?? [],
        }));
      })
      .catch(() => {
        setState((prevState) => ({...prevState, loading: false}));
      });
  }, [clientId, fieldTemplateId, projectId, type]);

  useEffect(() => {
    getFields();
  }, [getFields]);

  return {
    ...state,
    fields: (state.fields as IFieldModal[])?.sort((a: IFieldModal, b: IFieldModal) =>
      a.fieldLabel.toLowerCase().localeCompare(b.fieldLabel.toLowerCase())
    ),
  };
};
